<template>
  <section id="contact" class="section section--soft">
    <div class="container">
      <div class="contact-card">
        <div class="contact-copy">
          <span class="eyebrow">联系我们</span>
          <h2 class="contact-title">智能直播电商解决方案专家</h2>
          <p class="contact-sub">
            专注抖音 / 快手 / 小红书自动化运营 · 节省 80% 人力成本 · 达人建联效率提升 300%
          </p>

          <ul class="contact-points">
            <li>
              <span class="ico" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                </svg>
              </span>
              售前咨询、代理合作、OEM 贴牌均可扫码沟通
            </li>
            <li>
              <span class="ico" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M20 6 9 17l-5-5" />
                </svg>
              </span>
              提供软件试用、部署指导与售后答疑
            </li>
          </ul>
        </div>

        <figure class="contact-qr">
          <img src="@/assets/img/lxwm.png" alt="联系我们二维码" />
          <figcaption>扫码添加好友</figcaption>
        </figure>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ContactSection"
};
</script>

<style scoped>
.contact-card {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 48px;
  align-items: center;
  padding: 52px;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: var(--r-xl);
  box-shadow: var(--shadow-sm);
}

.contact-title {
  margin-top: 4px;
  color: var(--text-1);
  font-size: clamp(22px, 2.6vw, 32px);
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.3;
}

.contact-sub {
  margin-top: 14px;
  color: var(--text-2);
  font-size: 15px;
  line-height: 1.75;
}

.contact-points {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 26px;
  padding-top: 24px;
  border-top: 1px solid var(--border);
}

.contact-points li {
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--text-2);
  font-size: 14.5px;
}

.ico {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  border-radius: 50%;
  background: var(--brand-soft);
  color: var(--brand-dark);
}

.ico svg {
  width: 16px;
  height: 16px;
}

.contact-qr {
  text-align: center;
}

.contact-qr img {
  width: 216px;
  height: 216px;
  object-fit: contain;
  border-radius: var(--r-lg);
  background: #fff;
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
}

.contact-qr figcaption {
  margin-top: 12px;
  color: var(--text-3);
  font-size: 13px;
}

@media (max-width: 900px) {
  .contact-card {
    grid-template-columns: minmax(0, 1fr);
    gap: 30px;
    padding: 28px;
    text-align: left;
  }
  .contact-qr img {
    width: 180px;
    height: 180px;
  }
  .contact-qr {
    justify-self: center;
  }
}
</style>
